import { ErrorInfo } from 'react';

import { IS_DEV } from '@monoimin/constants';

export const trackError = (
  error: Error,
  errorInfo?: ErrorInfo,
  statusCode?: number
) => {
  if (IS_DEV) {
    return;
  }

  if (typeof window.TrackJS !== 'undefined') {
    window.TrackJS?.track({ message: error.message, info: errorInfo });
  }

  fetch('/api/log/', {
    method: 'POST',
    body: JSON.stringify({
      attributes: {
        errorMessage: error.message || null,
        info: errorInfo || null,
        stringified: error.toString(),
        url: window.location.href,
        deviceUserAgent: window.navigator.userAgent,
        statusCode: statusCode || null,
      },
      message: 'Next error',
    }),
  });
};
